"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const yup = require("yup");
const constants_1 = require("../constants");
exports.POST_VALIDATIONS = {
    TITLE_MIN: 10,
    TITLE_MAX: 450,
    DETAILS_MIN: 20,
    DETAILS_MAX: 10000,
};
exports.POST_ERR_MESSAGES = {
    POST_TITLE_NOT_VALID: `Title should be between ${exports.POST_VALIDATIONS.TITLE_MIN} and ${exports.POST_VALIDATIONS.TITLE_MAX} characters`,
    POST_DETAILS_NOT_VALID: `Details should be between ${exports.POST_VALIDATIONS.DETAILS_MIN} and ${exports.POST_VALIDATIONS.DETAILS_MAX} characters`,
    NOTING_TO_UPDATE: "nothing to update",
    POST_NOT_FOUND: "Post does not exist anymore",
};
exports.postTitleValidation = yup
    .string()
    .min(exports.POST_VALIDATIONS.TITLE_MIN, exports.POST_ERR_MESSAGES.POST_TITLE_NOT_VALID)
    .max(exports.POST_VALIDATIONS.TITLE_MAX)
    .required();
exports.postDetailsValidation = yup
    .string()
    .min(exports.POST_VALIDATIONS.DETAILS_MIN, exports.POST_ERR_MESSAGES.POST_DETAILS_NOT_VALID)
    .max(exports.POST_VALIDATIONS.DETAILS_MAX)
    .required();
exports.postCategoriesValidation = yup
    .string()
    .oneOf(constants_1.CategoryTypes)
    .required();
exports.postValidationSchema = yup.object().shape({
    title: exports.postTitleValidation,
    details: exports.postDetailsValidation,
    categories: exports.postCategoriesValidation,
});
//# sourceMappingURL=post.js.map


//////////////////
// WEBPACK FOOTER
// ../common/dist/yupSchemas/post.js
// module id = 743
// module chunks = 0